var _path, _path2, _path3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeveiligingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 236,
    viewBox: "0 0 286 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8594 13.6252C108.216 9.81258 127.018 6 144.686 6C180.045 6 215.513 21.2503 215.513 21.2503C215.513 21.2503 238.781 141.336 142.965 170.05",
    stroke: "#324A6D",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.966 170.028C47.8915 132.556 69.547 21.2285 69.547 21.2285",
    stroke: "#324A6D",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.483 80.0725L140.025 99.6147L176.909 62.7307",
    stroke: "#F7A941",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 143,
    cy: 217.424,
    rx: 143,
    ry: 18.2097,
    fill: "#EAF2F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeveiligingIcon);
export default __webpack_public_path__ + "static/media/beveiliging_icon.536c86b791360cccc020b7f4ab927c07.svg";
export { ForwardRef as ReactComponent };